<template>
	<div>
		<module-metaseo
				:data-update-role="true">
		</module-metaseo>
		<div class="card">
			<header class="card-header language-list">
				<h3 class="card-title">General Data</h3>
				<div class="ml-auto">
					<button @click="save" class="btn btn-sm btn-success">
						<i class="fas fa-save"></i> Save Changes
					</button>
				</div>
			</header>
			<div class="card-body">
				<image-uploader
						:data-title="'Featured Image'"
						:data-path="'/provider-type-categories/'"
						:data-post-url="'/uploadImage'"
						:data-model-id="providerTypeCategory.id"
						:data-image="dataProviderTypeCategory.featured_image_url"
				></image-uploader>
				<div class="form-group">
					<label for="card-title">Card Title</label>
					<input id="card-title" type="text" v-model="providerTypeCategory.card_title">
				</div>
				<div class="form-group">
					<label for="date">Display Date</label>
					<input id="date" type="date" v-model="providerTypeCategory.display_date">
				</div>
				<div class="form-group">
					<label for="card-description">Card Description</label>
					<textarea id="card-description" type="text" v-model="providerTypeCategory.card_description"></textarea>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			dataProviderTypeCategory: {
				type: Object
			}
		},
		data() {
			return {
				providerTypeCategory: this.dataProviderTypeCategory,
			}
		},
		methods: {
			save: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/provider-type-categories/' + vm.providerTypeCategory.id, vm.providerTypeCategory)
						.then(function (response) {
							vm.$toastr.success('Provider Type Category saved successfully', 'Success');
						}).catch(function (e) {
							vm.errors.record(e.response.data);
							vm.$toastr.error('Provider Type Category save failed.', 'Error');
						});
			}
		}
	}
</script>

<style scoped>

</style>
